import { render, staticRenderFns } from "./assonanceAlliterationSettings.vue?vue&type=template&id=4232a425&scoped=true"
import script from "./assonanceAlliterationSettings.vue?vue&type=script&lang=js"
export * from "./assonanceAlliterationSettings.vue?vue&type=script&lang=js"
import style0 from "./assonanceAlliterationSettings.vue?vue&type=style&index=0&id=4232a425&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4232a425",
  null
  
)

export default component.exports